'use strict';

import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Input from './Input';

import propIsVerifierInstance from 'ck-core/source/functions/propIsVerifierInstance';

export default class CheckboxInput extends React.Component {
	componentWillReceiveProps(nextProps) {
		if (this.props.value !== nextProps.value) {
			this.handleChange(nextProps.value);
		}
	}

	componentDidMount() {
		if (this.props.value) {
			this.handleChange(this.props.value);
		}
	}

	async validate(value) {
		let isValid;
		let error;

		if (this.props.optional && !value) {
			isValid = true;
		} else if (!this.props.validate) {
			isValid = !!value;
		} else {
			const result = await this.props.validate(value);
			isValid = _.get(result, 'valid', true);
			error = _.get(result, 'error');
		}

		if (this.props.onValidate) {
			this.props.onValidate(isValid, error);
		}
	}

	handleChange(value) {
		if (this.props.onChange) {
			this.props.onChange.call(this, value);
		}

		this.validate(value);
	}

	render() {
		return (
			<React.Fragment>
				{this.props.explanatoryText && <div>{this.props.explanatoryText}</div>}
				<Input {...this.props} className="CheckboxInput">
					<input
						type="checkbox"
						name={this.props.name}
						checked={this.props.value}
						disabled={this.props.disabled}
						onChange={event => {
							this.handleChange(event.target.checked);
						}}
					/>
				</Input>
			</React.Fragment>
		);
	}
}

CheckboxInput.defaultProps = {
	emptyValue: false
};

CheckboxInput.propTypes = {
	name: PropTypes.string.isRequired,
	explanatoryText: PropTypes.string,
	value: PropTypes.bool,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	onValidate: PropTypes.func,
	validate: PropTypes.oneOfType([PropTypes.func, propIsVerifierInstance]),
	optional: PropTypes.bool
};
